<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-24 16:32:20
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-24 16:47:23
 * @FilePath: /chaoyongtuan/src/components/activitySelect/activitySelect.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-select
		v-scroll-lazy-load="{
			loadData: activityLoadData,
			distance: 50,
			delay: 300,
			scrollBody: '.el-scrollbar__wrap',
			callback: fn => this.$once('hook:beforeDestroy', () => fn()),
		}"
		allow-create
        style="width: 100%;"
		v-model="activityId"
		filterable
		remote
		reserve-keyword
		placeholder="请输入活动ID或活动名称"
		:remote-method="activityRemoteMethod"
		:loading="activityPage.activityLoading"
	>
		<el-option
			v-for="item in activityPage.activityOptions"
			:key="item.activity_id"
			:label="`${item.activity_name}(${item.third_activity_id})`"
			:value="item.activity_id"
		>
		</el-option>
	</el-select>
</template>
<script>
import debounce from 'lodash/debounce';
import { syncActivityList } from '@/api/shopManage';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
    props:{
        platformId:{
            type: [Number,String],
            default: PLATFORM_DY.value,
        },
        authorityId:{
            type: [Number,String],
            default: '',
        }
    },
    watch:{
        activityId:{
            handler:function(val){
                this.$emit('input',val);
            },
            deep: true,
            immediate: true,
        }
    },
	data() {
		return {
            activityPage:{
                activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
            },
            activityId: '',
        };
	},
    methods:{
        async getActivityList() {
			this.activityPage.page_index == 1 && (this.activityPage.activityLoading = true);
			try {
				const res = await syncActivityList({
					platform_id: this.platformId,
					page_index: this.activityPage.page_index,
					page_size: this.activityPage.page_size,
					q: this.activityPage.query,
					authority_id: this.authorityId,
				});
				this.activityPage.activityOptions.push(...res.data.list);
				this.activityPage.page_index = res.data.page.page_index;
				this.activityPage.page_has = res.data.page.page_has;
			} finally {
				this.activityPage.activityLoading = false;
			}
		},
        activityLoadData() {
			if (this.activityPage.page_has && !this.activityPage.goodLoading) {
				this.activityPage.page_index = this.activityPage.page_index + 1;
				this.getActivityList();
			}
		},
        activityRemoteMethod: debounce(function(query) {
			this.activityPage.query = query;
			this.activityPage.page_index = 1;
			this.activityPage.activityOptions = [];
			this.getActivityList();
		}, 300),
        clear(){
            this.activityPage = {
				activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
            this.activityId = '';
        },
    }
};
</script>
<style lang="less" scoped></style>
